import { ChecklistDocumentSummary } from '@black-bear-energy/black-bear-energy-common'

export const checklistChildIsChecklist = (
  child: object
): child is ChecklistDocumentSummary => {
  return child.hasOwnProperty('checklistName')
}
